/* global */

import React from 'react';
import PropTypes from 'prop-types';
import { css as uicss } from 'panamera-react-ui';
import classNames from 'classnames';
import css from './ListingPageContent.desktop.scss';
import NavigationBarPlaceholder from 'Components/NavigationBar/components/NavigationBarPlaceholder.desktop';
import NavigationBar from 'Components/NavigationBar/NavigationBar.desktop';
import NavigationBarContainer from 'Components/NavigationBar/components/NavigationBarContainer.desktop';
import ListingCarouselWrapper from '../../../ReProjects/components/Carousel/ListingCarouselWrapper';
import SeoText from 'Components/Footer/SeoTextMX';

const { grid } = uicss;

export const ListingContent = props => {
    const {
        nav,
        banners,
        category,
        location,
        listingBody,
        similarAdsBody,
        gridClasses,
        notification,
        isFetchingItems,
        showCarouselFlag,
        navigationBarEnabled
    } = props;
    const { pathname } = location;

    const renderNavigationBar = isFetchingItems => {
        const { category } = props;

        return (
            <NavigationBarContainer>
                { isFetchingItems
                    ? <NavigationBarPlaceholder />
                    : <NavigationBar category={ category } />
                }
            </NavigationBarContainer>
        );
    };

    return (
        <section className={ css.listing }>
            <div className={ classNames(grid.row, css.listingContainer, { [css.container]: pathname === '/' }) }>
                <div className={ gridClasses }>
                    { nav }
                    { notification }
                    { banners }
                    <div style={ { display: 'flex' } }>
                        { renderNavigationBar(isFetchingItems) }
                        <div className={ classNames({
                            [css.withNavigation]: navigationBarEnabled,
                            [css.withOutNavigation]: !navigationBarEnabled }) }>
                            {
                                showCarouselFlag
                                && <ListingCarouselWrapper
                                    carouselApiRequestPath={ category && category.category_banner && category.category_banner.request_path }
                                />
                            }
                            { listingBody }
                            { similarAdsBody }
                        </div>
                    </div>
                </div>
            </div>
            <SeoText />
        </section>
    );
};

ListingContent.propTypes = {
    category: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    location: PropTypes.object.isRequired,
    isFetchingItems: PropTypes.bool,
    nav: PropTypes.node,
    listingBody: PropTypes.node,
    similarAdsBody: PropTypes.node,
    notification: PropTypes.node,
    banners: PropTypes.node,
    navigationBarEnabled: PropTypes.bool,
    showCarouselFlag: PropTypes.bool,
    gridClasses: PropTypes.string
};

ListingContent.defaultProps = {
    category: {},
    isFetchingItems: false,
    nav: undefined,
    listingBody: undefined,
    similarAdsBody: undefined,
    notification: undefined,
    banners: undefined,
    navigationBarEnabled: false,
    showCarouselFlag: false,
    gridClasses: ''
};

export default ListingContent;
